import { useState } from 'react'
import QRCode from 'react-qr-code'


const QrCode = ({item, size}) => {
    const[data,setData]=useState("Crop")
  return (
   <>

<QRCode className='qr-code'
       value={item}
       size={size} 
       fgColor="#000" 
       bgColor="white"
       />
   </>
  )
}

export default QrCode